export interface AdditionalGradeSelectOption {
  id: number
  label?: string
  labelKey?: string
}

export enum GradeOptionTypes {
  All = -1,
}
export const AllGradesOption: AdditionalGradeSelectOption = {
  id: GradeOptionTypes.All,
  labelKey: 'grade.all',
}
